export default __webpack_public_path__ + "road-map-800-11a154cbe8244ea7989f7dbe72cb31fe.webp";